import * as React from 'react';
import { DOCUMENT_SCROLL_DISABLE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
export function useDisablePageScroll(active) {
  React.useEffect(() => {
    if (!active) {
      return;
    }
    const subscriber = new Subscriber();
    getGlobalBehaviors().subscribe(DOCUMENT_SCROLL_DISABLE, subscriber);
    return () => {
      getGlobalBehaviors().unsubscribe(DOCUMENT_SCROLL_DISABLE, subscriber);
    };
  }, [active]);
}